/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IConversationResponse } from './IConversationResponse';
import {
    IConversationResponseFromJSON,
    IConversationResponseFromJSONTyped,
    IConversationResponseToJSON,
    IConversationResponseToJSONTyped,
} from './IConversationResponse';

/**
 * 
 * @export
 * @interface GetDmConversationResponse
 */
export interface GetDmConversationResponse {
    /**
     * 
     * @type {IConversationResponse}
     * @memberof GetDmConversationResponse
     */
    conversation: IConversationResponse;
    /**
     * Whether the conversation was just created
     * @type {boolean}
     * @memberof GetDmConversationResponse
     */
    created?: boolean;
}

/**
 * Check if a given object implements the GetDmConversationResponse interface.
 */
export function instanceOfGetDmConversationResponse(value: object): value is GetDmConversationResponse {
    if (!('conversation' in value) || value['conversation'] === undefined) return false;
    return true;
}

export function GetDmConversationResponseFromJSON(json: any): GetDmConversationResponse {
    return GetDmConversationResponseFromJSONTyped(json, false);
}

export function GetDmConversationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDmConversationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'conversation': IConversationResponseFromJSON(json['conversation']),
        'created': json['created'] == null ? undefined : json['created'],
    };
}

export function GetDmConversationResponseToJSON(json: any): GetDmConversationResponse {
    return GetDmConversationResponseToJSONTyped(json, false);
}

export function GetDmConversationResponseToJSONTyped(value?: GetDmConversationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversation': IConversationResponseToJSON(value['conversation']),
        'created': value['created'],
    };
}

